(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const content = root.querySelector('[data-ms-help-content]');
    const embeddedTitle = content.querySelector(':scope > h1');
    if (embeddedTitle) embeddedTitle.remove();
    const select = root.querySelector('[data-ms-help-select]');
    if (select) { root.querySelector('.ms-help__mobile-nav').hidden = false; select.addEventListener('change', () => { if (select.value) window.location.assign(select.value); }); }
    content.querySelectorAll('table').forEach((table) => { const wrapper = document.createElement('div'); wrapper.className = 'ms-help__table'; table.before(wrapper); wrapper.append(table); });
    if (root.hasAttribute('data-ms-help-faq')) {
      let list;
      [...content.children].forEach((element) => {
        if (element.tagName === 'H2') {
          list = document.createElement('div'); list.className = 'ms-help__faq-list'; element.after(list);
          if (/rückgabe|rücksendung/i.test(element.textContent)) element.id = 'ruecksendung';
        }
        if (element.tagName !== 'H3') return;
        if (!list) { list = document.createElement('div'); list.className = 'ms-help__faq-list'; element.before(list); }
        const details = document.createElement('details'); details.className = 'ms-help__faq'; details.name = `faq-${root.closest('[id]')?.id || 'help'}`;
        const summary = document.createElement('summary'); summary.textContent = element.textContent;
        const answer = document.createElement('div'); answer.className = 'ms-help__answer';
        let sibling = element.nextSibling;
        while (sibling && !['H2','H3'].includes(sibling.nodeName)) { const next = sibling.nextSibling; answer.append(sibling); sibling = next; }
        details.append(summary, answer); list.append(details); element.remove();
      });
    }
    if (location.hash) { const target = document.getElementById(decodeURIComponent(location.hash.slice(1))); if (target && root.contains(target)) target.scrollIntoView(); }
  };
  document.querySelectorAll('[data-ms-help]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-ms-help]').forEach(init));
})();
